// Browser mirror of packages/shared/src/schemas/quote-pdf.ts.
// Pinned by quotePdfContract.parity.test.ts; see docs/frontend-package-boundaries.md.
import { z } from 'zod';

export const quotePdfUuidSchema = z.string().uuid();

/** Authenticated live quote download, never a public URL or a frozen/send artifact. */
export function quotePdfPath(id: string): string {
  return `/api/v1/work-orders/${id}/quote-pdf`;
}

export const quotePdfFileNameSchema = z
  .string()
  .min(5)
  .max(200)
  .regex(/^[\p{L}\p{N} ._-]+\.pdf$/u);

export const quotePdfArtifactSchema = z
  .object({
    kind: z.literal('quote_pdf'),
    quoteId: z.string().uuid(),
    tenantId: z.string().uuid(),
    fileName: quotePdfFileNameSchema,
    contentType: z.literal('application/pdf'),
    downloadPath: z.string(),
    snapshot: z.literal('live'),
  })
  .strict()
  .refine(
    (value) => value.downloadPath === `${quotePdfPath(value.quoteId)}?tenant_id=${value.tenantId}`,
    {
      message: 'Download path must address this quote on the authenticated API.',
    }
  );

export type QuotePdfArtifact = z.infer<typeof quotePdfArtifactSchema>;

/** Only the tenant-bound, same-API quote download can use the bearer client. */
export function quotePdfDownloadPath(href: string | undefined): string | undefined {
  const match =
    /^\/api\/v1\/work-orders\/([\da-f-]{36})\/quote-pdf\?tenant_id=([\da-f-]{36})$/i.exec(
      href ?? ''
    );
  if (
    !match ||
    !quotePdfUuidSchema.safeParse(match[1]).success ||
    !quotePdfUuidSchema.safeParse(match[2]).success
  )
    return undefined;
  return href?.slice('/api/v1'.length);
}
